// Import the functions you need from the SDKs you need
import firebase from "firebase"

// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAeVOKUwgT-c4qPPyS6Hc7XGoc14d1L0Fs",
  authDomain: "plotfamily.firebaseapp.com",
  projectId: "plotfamily",
  storageBucket: "plotfamily.appspot.com",
  messagingSenderId: "518255531168",
  appId: "1:518255531168:web:3fe1812632db5a78a325c5",
  measurementId: "G-WV1DVL7CG9"
};

// Initialize Firebase

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const store = firebaseApp.database();
const auth = firebase.auth()
const storage = firebase.storage()

export {db,store, auth, storage};